var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385,
    height: 80,
    fill: "none",
    viewBox: "0 0 385 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 16.41v47.864h22.77c4.033 0 7.657-.547 9.914-1.436 7.18-2.94 12.24-10.052 12.24-18.257 0-6.974-3.625-13.06-9.163-16.615 0-4.787-2.94-8.957-7.18-10.667-1.367-.547-3.419-.889-5.812-.889H0Zm76.376 0H50.53v47.864h41.025l-7.247-10.94c6.7-3.01 11.35-9.778 11.35-17.573 0-10.667-8.615-19.35-19.282-19.35Zm70.974 47.863L121.025 16.41 94.769 64.274h52.581Zm40-47.863h-35.487v47.864h35.487V16.41Zm54.701 0h-23.932v13.128L194.188 16.41v47.864h47.863V16.41Zm53.265 0h-47.863l10.803 23.932v23.931h26.257v-23.93l10.803-23.932Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.615,
    cy: 40,
    r: 40,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M321.026 16.41h26.153l21.539 47.693h-26.154L321.026 16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M352.821 16.41h15.897l-21.539 47.693h-15.897l21.539-47.693Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M342.564 16.41h13.333l-21.538 47.693h-13.333l21.538-47.693Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h385v80H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.a72201da7e9b3dd483631165a31a6c1d.svg";
export { ForwardRef as ReactComponent };